<!--
  @component
  Generates an SVG area shape using the `area` function from [d3-shape](https://github.com/d3/d3-shape).
 -->
<script>
  import { getContext } from "svelte";
  import { area, curveMonotoneX } from 'd3-shape';

	const { xGet, yGet, xScale, yScale, extents } = getContext("LayerCake");

	/**  @type {String} [fill='#ab00d610'] The shape's fill color. This is technically optional because it comes with a default value but you'll likely want to replace it with your own color. */
	export let fill = "#ab00d6";
	export let opacity = 1;
	export let data = [];

  /*
	$: pathMax =
		"M" +
		data
			.map((d) => {
				return $xGet(d) + "," + $yScale(d.max);
			})
			.join("L");
	$: pathMin =
		"L" +
		data
			.map((d) => {
				return $xGet(d) + "," + $yScale(d.min);
			})
			.reverse()
			.join("L");

  let area;

  */
  let ar = area()
    .x($xGet)
    .y0(d => $yScale(d.min))
    .y1(d => $yScale(d.max))
    .curve(curveMonotoneX)


	let yRange = $yScale.range();
	let d = ar(data);
</script>

<path class="path-area" d={d} {fill} fill-opacity={opacity} />
